import axios, { AxiosRequestConfig } from 'axios';
import { addPending, removePending } from './axiosReqCancel';
import { environment } from 'environments/environment';
const API_V1 = `${environment.REACT_APP_BASE_URL}/api/v1/`;

// TO DO move to apiMap file
const byPassUrl = new Set([
  `${API_V1}appointment/next-available-slot`,
  `${API_V1}appointment/online-schedule`,
  `${API_V1}doctor/clinic-details`,
]);

axios.interceptors.request.use(interceptor => {
  if (interceptor.method === 'get' && !byPassUrl.has(interceptor.url as string)) {
    removePending(interceptor); // check and cancel the previous request before the request starts
    addPending(interceptor); // add the current request to pending
  }
  delete interceptor.headers.common.fuName;
  return interceptor;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  if (response.config.method === 'get') {
    removePending(response); // after the request, remove the request
  }
  return response;
}, error => {
  if (axios.isCancel(error)) {
    console.log(`Canceled repeated request: ${error.message}`);
  } else {
    // handle error code
  }
  return Promise.reject(error);
});

export default class restClient {

  static setHeader(key: string, value: string | undefined) {
    axios.defaults.headers.common[key] = value || '';
  }

  static getHeader(key?: string) {
    if (key)
      return axios.defaults.headers.common[key];

    return axios.defaults.headers.common;
  }

  static addInterceptor(interceptor: (value: AxiosRequestConfig) => AxiosRequestConfig, error: (error: any) => any) {
    axios.interceptors.request.use(interceptor, error);
  }

  static async makeGetRequest(url: string, { headers, ...params }: any | undefined = {}) {
    const response = await axios.get(url, params || headers ? { params, headers } : undefined);
    return response.data;
  }

  static async makePostRequest(url: string, data: any, config?: any) {
    const response = await axios.post(url, data, config);
    return response.data;
  }

  static async makePutRequest(url: string, data: any, config?: any) {
    const response = await axios.put(url, data, config);
    return response.data;
  }

  static async makeDeleteRequest(url: string, config?: any) {
    const response = await axios.delete(url, config);
    return response.data;
  }

}

export const headerKey = {
  AccessToken: 'access-token',
  AuthToken: 'AUTH-TOKEN',
  Authorization: 'authorization',
};